exports = module.exports = require("../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "html[dir] ._3oxF64zjm5Wav2SsNQlQmu{margin-bottom:1px}", ""]);
// Exports
exports.locals = {
	"quickAdd": "_3oxF64zjm5Wav2SsNQlQmu"
};